import {ActionList} from '@primer/react'
import {XIcon} from '@primer/octicons-react'
import {FeatureFlags} from '@primer/react/experimental'
import {clsx} from 'clsx'
import {useId, type PropsWithChildren, type Ref} from 'react'

import styles from './AhpTaskChatInputActionBar.module.css'

export interface ActionBarPanelProps extends PropsWithChildren {
  title: string
  onClose: () => void
  className?: string
  listTabIndex?: number
  closeButtonRef?: Ref<HTMLButtonElement>
  nonInteractive?: boolean
}

export function ActionBarPanel({
  title,
  onClose,
  className,
  listTabIndex,
  closeButtonRef,
  nonInteractive = false,
  children,
}: ActionBarPanelProps) {
  const headingId = useId()

  return (
    <FeatureFlags flags={{primer_react_action_list_group_heading_trailing_action: true}}>
      <section className={clsx(styles.ActionBarPanel, className)} aria-labelledby={headingId}>
        <ActionList
          aria-label={title}
          variant="horizontal-inset"
          tabIndex={listTabIndex}
          role={nonInteractive ? 'list' : undefined}
        >
          <ActionList.Group aria-label={nonInteractive ? title : undefined}>
            <ActionList.GroupHeading id={headingId} as="h2">
              {title}
              <ActionList.GroupHeading.TrailingAction
                className={styles.PanelCloseButton}
                icon={XIcon}
                label={`Close ${title.toLowerCase()}`}
                onClick={onClose}
                ref={closeButtonRef}
              />
            </ActionList.GroupHeading>
            {children}
          </ActionList.Group>
        </ActionList>
      </section>
    </FeatureFlags>
  )
}

ActionBarPanel.displayName = 'ActionBarPanel'
